<template>
  <div class="create">
    <Card v-model="loading">
      <div class="operations">
        <button @click="goBack">取消</button>
        <button @click="submit" class="release">发布</button>
      </div>
    </Card>
    <div class="form">
      <input v-model="title"  placeholder="输入召集令"/>
      <div class="form-item datetime" style="margin-right: 15px;">
        <label for="">时间</label>
        <div @click.stop="triggerTimePick" class="input">
          <div class="time">
            <div>{{formateDateTostr(currentDate, 'MM月DD日')}}</div>
            <div>{{formateDateTostr(currentDate, 'HH:mm')}}</div>
          </div>
          <span class="week">{{formateDateTostr(currentDate, '星期WEEK')}}</span>
        </div>
      </div>
      <div class="form-item item">
        <label for="">人数</label>
        <input class="date" v-model="limit" placeholder="填写0为不限人数"/>
      </div>
      <div class="form-item">
        <label for="">地点</label>
        <input class="date" v-model="address" placeholder="请填写地点"/>
      </div>
      <div class="form-item">
        <label for="">说明</label>
        <div class="textarea">
          <textarea name="" v-model="desc" maxlength="100" placeholder="令人心动的说明，会吸引TA报名哦~" id=""></textarea>
          <span class="total">{{desc.length}}/100</span>
        </div>
      </div>
    </div>
    <van-popup v-model="triggerTime" position="bottom" :style="{ height: `${6 * 44}px` }" >
      <van-datetime-picker
      @confirm="close"
      @cancel="close"
      v-model="currentDate"
      title="请选择年月日时分"
      :filter="filter"
      :min-date="minDate"
    />
    <!-- :max-date="maxDate" -->
    </van-popup>
    <SetNickName :show="showSetNickName" @close="showSetNickName = false"/>
  </div>
</template>
<script>
import { DatetimePicker, Popup, Toast } from 'vant'
import { formateDateTostr, formateRegexToDate } from '../../../utils/date'
import { post, get } from '../../../utils/request'
import { get as getUser } from '../../../utils/token'
import Card from '../../../components/CardLoading'
import { createNamespacedHelpers } from 'vuex'
import AuthMixis from '../../../minixs/auth'
const { mapActions } = createNamespacedHelpers('tabbar')
export default {
  mixins: [AuthMixis],
  components: {
    'van-datetime-picker': DatetimePicker,
    'van-popup': Popup,
    Card
  },
  data () {
    const date = new Date()
    date.setDate(date.getDate() + 1)
    date.setHours(12)
    const user = getUser('user')
    return {
      triggerTime: false,
      minDate: new Date(),
      // maxDate: new Date('2020-12-30'.replace(/-/g, '/')), //此代码产生了无法选择时间的BUG
      currentDate: date,
      desc: '',
      title: `${user.fullname !== '' && user.fullname !== 'null' ? user.fullname : user.nickName}发起的召集令`,
      address: '',
      limit: '',
      assembleTime: '',
      loading: false
    }
  },
  mounted () {
    this.getDetails()
  },
  methods: {
    filter (type, options) {
      if (type === 'minute') {
        return options.filter((option) => option % 15 === 0)
      }
      return options
    },
    ...mapActions({
      updateTabIndex: 'updateTabIndex'
    }),
    goBack () {
      this.$router.back()
    },
    close () {
      this.triggerTime = false
    },
    getDetails () {
      const user = getUser('user')
      const { id } = this.$route.query
      if (!id) {
        return
      }
      const promise = get({
        url: `/call/talesDetail/${id}/${user.id}`
      })
      promise.then(res => {
        const { status, data: { detail } } = res
        if (Object.is(status, 200)) {
          const { assembleTime } = detail
          this.currentDate = formateRegexToDate(assembleTime)
          Object.assign(this, detail)
        }
      })
    },
    submit () {
      const flag = this.judgeUserNickName()
      if (flag) {
        return
      }
      if (!`${this.limit}` || !this.address || !this.desc) {
        Toast.fail('你填写的信息不完整，请填写完整后提交!')
        return
      }
      this.loading = true
      const { id } = this.$route.query
      const user = getUser('user')
      const params = {
        user: user.id,
        title: this.title,
        desc: this.desc.replace(/\n/g, '<br/>'),
        address: this.address,
        limit: this.limit,
        assembleTime: formateDateTostr(this.currentDate, 'YYYY-MM-DD HH:mm')
      }
      let promise = null
      if (id) {
        params.id = id
        // console.log('请求方式PUT:' + params)
        promise = post({
          url: `/call/tales/${user.id}/edit`,
          data: params,
          timeout: 20000
        })
      } else {
        // console.log('请求方式post:' + params)
        promise = post({
          url: `/call/tales/${user.id}`,
          data: params,
          timeout: 200000
        })
      }
      promise.then(res => {
        const { data: { code } } = res
        if (Object.is(code, 200)) {
          this.updateTabIndex('dynamic')
          this.loading = false
          // this.$router.replace({
          //   path: '/exerland/bbs/dynamic?active=SummoningOrder'
          // })
          // this.$router.replace('/exerland/bbs/dynamic?active=SummoningOrder')
          this.$router.replace({
            name: 'Dynamic',
            query: {
              active: 'SummoningOrder'
            },
            params: {
              ispublish: true
            }
          })
        }
      })
    },
    formateDateTostr (date, str) {
      return formateDateTostr(date, str)
    },
    triggerTimePick () {
      this.triggerTime = !this.triggerTime
    }
  }
}
</script>
<style lang="scss" scoped>
.create {
  box-sizing: border-box;
  padding: 12px 16px;
  width: 100%;
  height: 100vh;
  overflow-y: scroll;
  .operations {
    height: 48px;
    width: 100%;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
    button {
      font-size:17px;
      font-family:PingFangSC-Regular,PingFang SC;
      font-weight:400;
      color:rgba(0,0,0,1);
      background: #fff;
      line-height:24px;
      outline: none;
      border: none;
    }
    .release {
      height:32px;
      background:rgba(24,204,159,1);
      border-radius:4px;
      color:rgba(255,255,255,1);
      padding: 4px 11px;
    }
  }
  .form {
    margin-top: 20px;
    width: 100%;
    box-sizing: border-box;
    input, .input {
      box-sizing: border-box;
      width: 100%;
      // height: 58px;
      // line-height: 58px;
      border-radius:6px;
      border:1px solid rgba(229,229,229,1);
      padding: 18px 16px;
      outline: none;
      -webkit-appearance: none;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    }
    .textarea {
      padding: 16px 16px 36px;
      height: 190px;
      box-sizing: border-box;
      border-radius:6px;
      border:1px solid rgba(229,229,229,1);
      position: relative;
      textarea {
        width: 100%;
        height: 138px;
        border: none;
      }
      .total {
        position: absolute;
        right: 6px;
        bottom: 6px;
        font-size:17px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(136,136,136,1);
        line-height:24px;
      }
    }
    ::-webkit-input-placeholder {
      font-size:15px;
      font-family:PingFangSC-Regular,PingFang SC;
      font-weight:400;
      color:rgba(204,204,204,1);
      line-height:22px;
    }
    .form-item {
      width: 100%;
      margin-top: 16px;
      display: inline-flex;
      flex-direction: column;
      box-sizing: border-box;
      label {
        font-size:13px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(136,136,136,1);
        line-height:18px;
        margin-bottom: 6px;
      }
    }
    .item, .datetime {
      width: calc(50% - 7.5px);
    }
    .datetime {
      .input {
        padding: 5px 6px 5px 19px;
        display: flex;
        align-items: center;
        .time {
          margin-right: 13px;
          div {
            font-size:15px;
            font-family:PingFangSC-Regular,PingFang SC;
            font-weight:400;
            color:rgba(0,0,0,1);
            line-height:22px;
          }
        }
        .week {
          font-size:17px;
          font-family:PingFangSC-Semibold,PingFang SC;
          font-weight:600;
          color:rgba(0,0,0,1);
          line-height:22px;
        }
      }
    }
  }
  .van-datetime-picker {
    position:fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: auto;
    box-shadow: 0 -2px 12px 5px rgba(0, 0, 0, 0.1);
  }
}
</style>
